module.exports = __webpack_public_path__ + "fae9a1bb3b5786f476932c3a0f7906ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/borer.jpg
// module id = 279
// module chunks = 1